import Vue from 'vue';
import Toasted from 'vue-toasted';

// Aquí se registran los plugins de la aplicación de Vue. En principio sólo habrá uno,
// el plugin de Toast https://github.com/shakee93/vue-toasted
// si eventualmente se añaden se podrían separar cada uno en su fichero

export default () => {
  Vue.use(Toasted);
  Vue.toasted.register(
    'commentError',
    ({ message }) => {
      if (!message) {
        return 'Se ha producido un error al realizar la acción. Por favor, inténtelo más tarde.'
      }
      return `Se ha producido un error: ${message}. Por favor, inténtalo más tarde.`
    },
    {
      type: 'error',
      position: 'bottom-center',
      duration: 4000,
      singleton: true
    }
  );

  Vue.toasted.register(
    'commentModerated',
    () => {
      return "Tu comentario está pendiente de moderación y será publicado más tarde."
    },
    {
      type: 'success',
      position: 'bottom-center',
      duration: 4000,
      singleton: true
    }
  );

  Vue.toasted.register(
    'unmuteUser',
    ({ message }) => {
      if (!message) {
        return 'El usuario ya no se encuentra silenciado.';
      }
      return `El usuario @${message} ya no se encuentra silenciado.`;
    },
    {
      type: 'info',
      position: 'bottom-center',
      duration: 4000,
      singleton: true
    }
  );

  Vue.toasted.register(
    'successReport',
    () => {
      return `El reporte ha sido enviado con éxito.`;
    },
    {
      type: 'success',
      position: 'bottom-center',
      duration: 4000,
      singleton: true
    }
  );
};
